import { type BTServiceFileUpload } from "legacyComponents/FileUploadContainer.types";

import {
    billsBulkOcrUploadPostV2,
    billsBulkOcrUploadProcessingStatusGetV2,
} from "handlers/bills/bills";
import type { BulkBillProcessingStatusResponse } from "handlers/models/bulkBillProcessingStatusResponse";
import type { BulkBillUploadResponse } from "handlers/models/bulkBillUploadResponse";

export interface IBulkBillUploadHandler {
    bulkOcrUpload(files: BTServiceFileUpload[]): Promise<BulkBillUploadResponse>;
    getProcessingStatus(batchId: string): Promise<BulkBillProcessingStatusResponse>;
}

export class BulkBillUploadHandler implements IBulkBillUploadHandler {
    async bulkOcrUpload(files: BTServiceFileUpload[]): Promise<BulkBillUploadResponse> {
        const response = await billsBulkOcrUploadPostV2({ uploadedFiles: files });
        return response.data;
    }

    async getProcessingStatus(batchId: string): Promise<BulkBillProcessingStatusResponse> {
        const response = await billsBulkOcrUploadProcessingStatusGetV2({ batchId });
        return response.data;
    }
}
